import React from 'react';

import { useTranslation } from 'react-i18next';
import { Card, Heading, Spinner, Text, Box, VStack, HStack, useToken, Pressable } from '@gluestack-ui/themed';
import { CircleCheck } from 'lucide-react-native';
import { tasksToSections } from '../utils/tasksToSections';

import TaskItemMobile from './TaskItemMobile';

const LevelCompletedIcon = () => (
  <CircleCheck size={20} color="$white" fill="$statusInfo" strokeWidth={1.6} />
);

const TaskListCards = ({ module, tasks, currentTask, handleSelectTask, selectedModule, ...props }) => {
  const { t } = useTranslation();

  const sectionedTasks = tasksToSections(module, tasks);

  const levelCompleted = (level) => {
    // do all tasks of a level have task.submission.state == "marked_as_done"?
    const tasksOfLevel = sectionedTasks.find((section) => section.level === level)?.data;
    const allTasksCompleted = tasksOfLevel.every((task) => task.submission?.state === 'marked_as_done');
    return allTasksCompleted;
  };

  return (
    <Box testID="task-list-cards" {...props}>
      <Heading size="lg" mt={0}>
        {t('student.module.task-list.title')}
      </Heading>
      {!tasks ? (
        <Spinner selfAlign="center" />
      ) : (
        sectionedTasks.map((section) => (
          <VStack key={section.level}>
            <HStack width="100%" justifyContent="space-between" alignItems="center" space="sm" my={28}>
              <VStack testID={`task-list-cards-level-${section.level}`} flex={1}>
                <Text size="sm" mb="$1" color="$textLight500">{`${t('student.module.task-list.level')} ${
                  section.level
                }`}</Text>
                <Heading size="sm">{section.title}</Heading>
              </VStack>
              <Box>{levelCompleted(section.level) ? <LevelCompletedIcon /> : null}</Box>
            </HStack>
            <VStack>
              {section.data.map((item) => (
                <Pressable key={item.id} onPress={() => handleSelectTask(item)}>
                  <Card testID={`task-item-box-${item.id}`} bg="white" mb="$2" borderRadius={12} variant="outline">
                    <TaskItemMobile task={item} module={module} selectedModule={selectedModule} tasks={tasks} />
                  </Card>
                </Pressable>
              ))}
            </VStack>
          </VStack>
        ))
      )}
    </Box>
  );
};

export default TaskListCards;
